export const TRACKING_SITE_AREA = 'cable';
export const TRACKING_ERROR_ACTION = 'displayed';
export const NAME_ACCORDION = 'accordion';
export const NAME_FOOTNOTE = 'footnote';
